import { render, staticRenderFns } from "./BenchmarkConfigEditor.vue?vue&type=template&id=921ee0e2&scoped=true"
import script from "./BenchmarkConfigEditor.vue?vue&type=script&lang=js"
export * from "./BenchmarkConfigEditor.vue?vue&type=script&lang=js"
import style0 from "./BenchmarkConfigEditor.vue?vue&type=style&index=0&id=921ee0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921ee0e2",
  null
  
)

export default component.exports